var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftHowItWorksArrowhead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "132 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.5 5.13397C140.167 5.51888 140.167 6.48113 139.5 6.86603L133.5 10.3301C132.833 10.715 132 10.2339 132 9.4641L132 2.5359C132 1.7661 132.833 1.28497 133.5 1.66987L139.5 5.13397Z",
    fill: "#A9B6D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftHowItWorksArrowhead);
export default __webpack_public_path__ + "static/media/gift-how-it-works-arrowhead.55ca978bf9b5ba66803aabeb2abe4bf7.svg";
export { ForwardRef as ReactComponent };